module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑轮播banner")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.bannerForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传banner图",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://upload.qiniup.com/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.beforeAvatarUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转类型选择",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.bannerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "type", $$v)
      },
      expression: "bannerForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("商品标签")])], 1)], 1), _vm._v(" "), (_vm.bannerForm.type === '0') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品类型",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '2') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.type === '1') ? _c('el-form-item', {
    attrs: {
      "label": "已选商品标签",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.bannerForm.choosedName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "choosedName", $$v)
      },
      expression: "bannerForm.choosedName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择分类"
    },
    model: {
      value: (_vm.chooseCatogry),
      callback: function($$v) {
        _vm.chooseCatogry = $$v
      },
      expression: "chooseCatogry"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_categroy
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.cur_categroy.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_categroy, "now", $$v)
      },
      expression: "cur_categroy.now"
    }
  }, _vm._l((_vm.categoryArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseCatogry = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.catogryChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择标签"
    },
    model: {
      value: (_vm.chooseTopic),
      callback: function($$v) {
        _vm.chooseTopic = $$v
      },
      expression: "chooseTopic"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_topic
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择标签",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "标签"
    },
    model: {
      value: (_vm.cur_topic.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_topic, "now", $$v)
      },
      expression: "cur_topic.now"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseTopic = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.topicChoose
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择商品"
    },
    model: {
      value: (_vm.chooseProduct),
      callback: function($$v) {
        _vm.chooseProduct = $$v
      },
      expression: "chooseProduct"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.cur_product
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    model: {
      value: (_vm.cur_product.now),
      callback: function($$v) {
        _vm.$set(_vm.cur_product, "now", $$v)
      },
      expression: "cur_product.now"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chooseProduct = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.productChoose
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ac1721"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/EditBanner.vue
// module id = 722
// module chunks = 1